function Label(props) {
    return (
        <span className="label">{props.text}</span>
    )
}

export default Label;